<template>
    <div class="fountain-section" v-if="landArr != null" id="menu-link-fountain">
        <div class="container">
            <sectionTitle :options="[{ title : landArr.fountain_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: landArr.fountain_quote_img, title : landArr.fountain_quote_title, desc: landArr.fountain_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : landArr.fountain_desc_left, desc_right: landArr.fountain_desc_right}]" class="section-desc-column-fountain"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: landArr.fountain_cards[0].images}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <landImagesGrid :options="[{ cards: landArr.fountain_cards, grid_img : landArr.fountain_img}]" class="land-images-grid-mix"></landImagesGrid>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import landImagesGrid from '@/components/landscaping/land-images-grid.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'land-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            landArr: 'loadLandArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            landImagesGrid,
            sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/landscaping/fountain-section.scss';
    @import '@/styles/components/landscaping/respond/fountain-section-respond.scss';
</style>